import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AppRoute, AppRoutes } from '../../routes';

import { StarfishDeviceProfileData } from '../../components/DeviceProfile/StarfishDeviceProfileData';

import { useStarfishDeviceDetails, StarfishGatewayDeviceDetailsProvider } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';

import { isDataLoaded } from '../../types';
import { DataIndicators } from '../../components/DataIndicators';
import { GenericToolbar } from '../../components/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { StarfishDeviceData } from '../../types/device';

import { SignalRSiteDataProvider } from '../../data/DataProviders/SignalRSiteDataProvider';
import { EditStarfishConnectedDevice } from '../../components/DeviceProfile/EditStarfishConnectedDevice';
//import { EditStarfishConnectedDevice } from './EditStarfishConnectedDevice';



export const StarfishDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    const { t } = useLanguageLocale();

    const starfishDeviceDetails = useStarfishDeviceDetails();
    const currentPage = currentAppRoute.type === 'StarfishDeviceProfile' ? 'StarfishDeviceProfile' : 'EditStarfishConnectedDevice';

    const starfishGatewayName = isDataLoaded(starfishDeviceDetails) ? starfishDeviceDetails.value.name : '';

    const [starfishGatewayDeviceData, setStarfishGatewayDeviceData] = useState<StarfishDeviceData | null>(null);
    const [childDeviceList, setchildDeviceList] = useState<any[]>([]);
    const updateGatewayDeviceData = (modifiedData: StarfishDeviceData): void => {
        if (isDataLoaded(starfishDeviceDetails)) {
            const data = { ...starfishDeviceDetails.value };
            data.name = modifiedData.name;
            data.deviceIP = modifiedData.deviceIP
            data.serial = modifiedData.serial;
            data.mac = modifiedData.mac;
            data.pushRate = modifiedData.pushRate;
            setStarfishGatewayDeviceData(data);
        }
    };


    useEffect(() => {
        if (isDataLoaded(starfishDeviceDetails)) {
            setStarfishGatewayDeviceData(starfishDeviceDetails.value);

            if (starfishDeviceDetails.value.childDevices) {

                setchildDeviceList(starfishDeviceDetails.value.childDevices);
            }
        }

    }, [starfishDeviceDetails]);

    const backRoute = (orgId: string, locationId: string, siteId: string, deviceId: string): AppRoute =>
        currentPage === 'StarfishDeviceProfile'
            ? { type: 'SiteProfile', orgId: orgId, locationId: locationId, siteId: siteId }
            : {
                type: 'StarfishDeviceProfile',
                deviceId: deviceId,
                locationId: locationId,
                orgId: orgId,
                siteId: siteId,
            };

    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />
            {isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>

                        {(currentAppRoute.type === 'StarfishDeviceProfile' ||currentAppRoute.type === 'EditStarfishConnectedDevice' ) && (
                            <GenericToolbar
                                showBackButton
                                backButtonOnClick={(): void => {
                                    pushAppRoute(
                                        history,
                                        backRoute(
                                            selectedOrganization.value.id,
                                            currentAppRoute.locationId,
                                            currentAppRoute.siteId,
                                            currentAppRoute.deviceId
                                        )
                                    );
                                }}
                                title={currentPage === 'StarfishDeviceProfile' ? starfishGatewayName : 'Edit Starfish Connected Device'}
                                subtitle={currentPage === 'StarfishDeviceProfile' ? 'Connected Device Profile' : starfishGatewayName}
                            />
                        )}

                        {/* <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={pxdbDeviceDetails}
                            isEmpty={false}
                        /> */}

                        {/* {isDataLoaded(pxdbDeviceDetails) && (
                            <Switch> 
                                <Route exact path={AppRoutes.PxDeviceProfile}>
                                    <SignalRSiteDataProvider siteId={currentAppRoute.siteId} locationId={currentAppRoute.locationId}>
                                            <PxDeviceProfileData
                                                data={gatewayDeviceData}
                                                backAppRoute={backRoute(
                                                    selectedOrganization.value.id,
                                                    currentAppRoute.locationId,
                                                    currentAppRoute.siteId,
                                                    currentAppRoute.deviceId
                                                )}
                                                childDeviceList={childDeviceList}
                                            />                                      
                                    </SignalRSiteDataProvider>  
                                </Route>
                               
                            </Switch>
                        )} */}

                        <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={starfishDeviceDetails}
                            isEmpty={false}
                        />

                        {isDataLoaded(starfishDeviceDetails) && (
                            <Switch>
                                <Route exact path={AppRoutes.StarfishDeviceProfile}>
                                    <SignalRSiteDataProvider siteId={currentAppRoute.siteId} locationId={currentAppRoute.locationId}>
                                        <StarfishGatewayDeviceDetailsProvider deviceId={currentAppRoute.deviceId}>

                                            <StarfishDeviceProfileData
                                                data={starfishGatewayDeviceData}
                                                backAppRoute={backRoute(
                                                    selectedOrganization.value.id,
                                                    currentAppRoute.locationId,
                                                    currentAppRoute.siteId,
                                                    currentAppRoute.deviceId
                                                )}
                                                childDeviceList={childDeviceList}
                                            />

                                        </StarfishGatewayDeviceDetailsProvider>
                                    </SignalRSiteDataProvider>

                                </Route>
                                <Route path={[AppRoutes.EditStarfishConnectedDevice]}>
                                    <EditStarfishConnectedDevice
                                        gatewayDetails={starfishGatewayDeviceData}
                                        updateGatewayDeviceData={updateGatewayDeviceData}
                                    />
                                </Route>

                            </Switch>
                        )}

                    </>
                )}
        </>
    );
};
